import React, { createContext, useContext } from 'react';
import type { AlertColor } from '@mui/material';

export type SystemAlertOptions = {
  severity?: AlertColor; // 'success' | 'info' | 'warning' | 'error'
  durationMs?: number;   // auto hide duration
};

export type SystemAlertApi = {
  show: (message: string, options?: SystemAlertOptions) => void;
  success: (message: string, options?: Omit<SystemAlertOptions, 'severity'>) => void;
  info: (message: string, options?: Omit<SystemAlertOptions, 'severity'>) => void;
  warning: (message: string, options?: Omit<SystemAlertOptions, 'severity'>) => void;
  error: (message: string, options?: Omit<SystemAlertOptions, 'severity'>) => void;
};

export const SystemAlertContext = createContext<SystemAlertApi | null>(null);

export function useSystemAlert(): SystemAlertApi {
  const ctx = useContext(SystemAlertContext);
  if (!ctx) {
    throw new Error('useSystemAlert must be used within SystemAlertProvider');
  }
  return ctx;
}
